import Accordion from "../../containers/Accordion/Accordion"
// import FormContext from '../../Context/form-context'
import React,{useEffect,useState} from "react";
import ReactDOM from "react-dom";

class Form extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        items:[],
        searchQueryForm:''
      };
    }
    handleSearchForm=(event)=>{
        event.preventDefault();
        let query = event.target.value;
        let filteredItems=this.props.items.filter((item)=>{
            return (item.FormNumber ? item.FormNumber.includes(query) :null) || item.FormContent.includes(query)
        });

        this.setState({items:filteredItems,
                    searchQueryForm: query})
    }


   

    componentDidUpdate(prevProps,prevState){
        
        if(prevProps.items.length != this.props.items.length)
        {
            this.setState(
                {  
                    items:this.props.items
                }
            )
        }
        addEventListener("keydown",this.props.handleUserKeypress);
      }

      componentWillUnmount(){
          removeEventListener("keydown",this.props.handleUserKeypress);
      }

    render(){
        let formsType= this.props.layout == 'first' ? 'הוראות' :'טפסים' ;
        let total= <div className="resultsNum"><h2>סה"כ {this.state.items.length} {formsType}
        {this.state.searchQueryForm ? " עבור " : ""}  <b className={this.state.searchQueryForm ?"show":"hide"}>"{this.state.searchQueryForm }"</b></h2></div>
        return(
                <React.Fragment>
                    <div className="searchFormArea">
                    <form onSubmit={this.handleSearchForm}>
                        <label htmlFor="searchQueryForm" className="sr-only" >חיפוש טפסים</label>
                        <input type='search' className='searchFormInput' id="searchFormsInput"  onKeyUp={this.handleSearchForm.bind(this)} placeholder="חפש" />
                        <i className="fa fa-search"  aria-hidden="true"/>
                    </form>
                       {total}
                    </div>
                    <Accordion items={this.state.items} 
                    WpId={this.props.WpId}
                    layout={this.props.layout}
                    type={this.props.type}
                    limit={this.props.limit}
                    moreTitle={this.props.moreTitle} />
                </React.Fragment>
        )
    }
}
export default Form